export default __webpack_public_path__ + "assets/images/ea3e097c28d11b32549f39144bf580e7.jpg";